import React, { FC } from 'react';
import { useBlackcart } from '../../context';

interface ILineItemTotalWrapperProps {
  variantId: string;
  showOldPrice?: boolean;
}

const LineItemTotalWrapper: FC<ILineItemTotalWrapperProps> = ({
  variantId,
  showOldPrice,
  children
}) => {
  const { isTBYBItem, bcCart } = useBlackcart();

  const lineItem = bcCart && bcCart.items.find((item) => item.variantId === variantId);

  if (isTBYBItem(variantId) && lineItem) {
    return (
      <span className="bc-cart-lineItem-total__root">
        <span className="bc-cart-lineItem-total__newPrice">
          {lineItem.formattedPrices.lineTotal}
        </span>
        {showOldPrice && (
          <span className="bc-cart-lineItem-total__oldPrice">&nbsp;({children} if kept)</span>
        )}
      </span>
    );
  } else {
    return <>{children}</>;
  }
};

export { LineItemTotalWrapper };
